import { Component, OnInit, OnDestroy } from '@angular/core';
// import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit, OnDestroy {
  public blog

  constructor(
    // private helperService:HelperService
  ) { }

  ngOnInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    let url = document.URL
    let splitUrl = url.split("/")
    if (splitUrl[4] === undefined) {
      this.blog = true
    }
    else {
      this.blog = false
    }
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }

}
